export default {"src":"/_next/static/media/redcabbage.b7d94aa6.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};